<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6JdGZO/tc-custom/9781639550012.jpg?1728259553816" alt="This image is the cover for the book Ask the Brindled"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ask the Brindled
      </h1>
      <p class="bookDescription body article font2">
        <p>Ask the Brindled, selected by Rick Barot as a winner of the 2021 National Poetry Series, bares everything that breaks between “seed” and “summit” of a life—the body, a people, their language. It is an intergenerational reclamation of the narratives foisted upon Indigenous and queer Hawaiians—and it does not let readers look away.    In this debut collection, No‘u Revilla crafts a lyric landscape brimming with shed skin, water, mo‘o, ma‘i. She grips language like a fistful of wet guts and inks the page red—for desire, for love, for generations of blood spilled by colonizers. She hides knives in her hair “the way my grandmother—not god— / the way my grandmother intended,” and we heed; before her, “we stunned insects dangle.” Wedding the history of the Kingdom of Hawai?i with contemporary experiences of queer love and queer grief, Revilla writes toward sovereignty: linguistic, erotic, civic. Through the medium of formal dynamism and the material of ?Oiwi culture and mythos, this living decolonial text both condemns and creates.   Ask the Brindled is a song from the shattered throat that refuses to be silenced. It is a testament to queer Indigenous women who carry baskets of names and stories, “still sacred.” It is a vow to those yet to come: “the ea of enough is our daughters / our daughters need to believe they are enough.”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        No'u Revilla, Rick Barot
      </h2>
      
      <p class="authorDescription body article"><P><B>No&#699;u Revilla</B> is the author of <I>Ask the Brindled</I>. She is an &#699;Oiwi (Native Hawaiian) queer poet and educator. Her work has been featured or is forthcoming in <I>Poetry</I>, Literary Hub, <I>ANMLY</I>, <I>Beloit</I>, the Honolulu Museum of Art, and the Library of Congress.&#160;Her latest chapbook,&#160;<I>Permission to Make Digging Sounds</I>,<I>&#160;</I>was published in&#160;<I>Effigies III</I>&#160;in 2019, and she has performed throughout Hawai&#699;i as well as Canada, Papua New Guinea, and the United Nations.&#160;She is an assistant professor at the University of Hawai&#699;i-M&#257;noa, where she teaches creative writing with an emphasis on &#699;Oiwi literature, spoken word, and decolonial poetics. Born and raised in Wai&#699;ehu on the island of Maui, she currently lives and loves in the valley of P&#257;lolo on the island of O&#699;ahu.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e500c66